import {
  ApolloClient,
  NormalizedCacheObject,
  useLazyQuery
} from '@apollo/client';
import {
  PathwayContentData,
  PathwayContentVars,
  PathwayData,
  PathwayVars,
  PathwaysData,
  PathwaysVars
} from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import { ContentType } from 'dashboard/models/Pathway';
import GraphQL from '../gql';
import useLazyQueryMutable from '../../shared/hooks/useLazyQueryMutable';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

function usePathways() {
  if (!dashboardApolloClient) {
    dashboardApolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

  const { fetchQuery, loading, error, data } = useLazyQueryMutable<
    PathwaysData,
    PathwaysVars
  >({
    client: dashboardApolloClient,
    query: GraphQL.Query.PATHWAYS,
    options: {
      fetchPolicy: 'network-only'
    },
    shouldMutate: true
  });

  function getPathways(userkey: number) {
    fetchQuery({
      variables: {
        userkey
      }
    });
  }

  const [
    _getCourse,
    { loading: loadingCourse, error: loadCourseError, data: course }
  ] = useLazyQuery<PathwayData, PathwayVars>(GraphQL.Query.COURSE, {
    client: dashboardApolloClient,
    fetchPolicy: 'no-cache'
  });

  const getCourse = (coursekey: string) => {
    _getCourse({
      variables: {
        coursekey
      }
    });
  };

  const [
    _getPathwayContent,
    {
      called: pathwayCalled,
      loading: pathwayLoading,
      error: pathwayError,
      data: pathwayData
    }
  ] = useLazyQuery<PathwayContentData, PathwayContentVars>(
    GraphQL.Query.PATHWAY_CONTENT,
    {
      client: dashboardApolloClient,
      fetchPolicy: 'cache-and-network'
    }
  );

  function getPathwayContent(
    userkey: number,
    pathkey: string,
    type: ContentType
  ) {
    _getPathwayContent({
      variables: {
        userkey,
        pathkey,
        type
      }
    });
  }

  return {
    getPathways,
    loading,
    error: !!error,
    pathways: data?.pathways ?? [],
    getPathwayContent,
    pathwayCalled,
    pathwayLoading,
    pathwayError,
    pathwayData,
    getCourse,
    courseData: course?.course || undefined,
    loadingCourse,
    loadCourseError
  };
}

export default usePathways;
